import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z"/><path d="M22,8v3H10V8H22m1.5-2H8.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-6a.5.5,0,0,0-.5-.5Z"/><path d="M11,16H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M17,16H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M17,20H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M23,16H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M11,20H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M23,20H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M17,24H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M11,24H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M23,24H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/>';
export var CalculatorOutlineSVG = function CalculatorOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CalculatorOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CalculatorOutlineSVG);